import { render } from "./Loading.vue?vue&type=template&id=30619526"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=30619526&lang=css"
script.render = render

export default script